export default "__VITE_ASSET__BTInSEDc__"